import React from 'react';
import { withTranslation } from '@i18n';

import {
  StyledCover,
  StyledAboutHeading,
  StyledAimSection,
  StyledAimMainWrapper,
  StyledWidthWrapper,
  StyledTimelineWapper,
  StyledTimelineTitle,
  StyledTimeline,
  StyledTimelineDesciption,
  StyledTimelineDesciptionCard,
  StyledTimelinePoint,
  StyledLogoWrapper,
  StyledTimelineBorder,
  StyledTImelineResponsiveWrapper
} from './styles';

const Advantages = ({ t }) => {
  const aimDesc = t('Advanatges', { returnObjects: true });
  const image = ['TravelVisa', 'Forex', 'Embassy', 'TeleMedicineAdv'];

  return (
    <StyledCover>
      <StyledAimSection>
        <StyledAboutHeading>{t('AdvantagesTitle')}</StyledAboutHeading>
        <StyledWidthWrapper>
          <StyledAimMainWrapper>
            <StyledTimelineWapper>
              {aimDesc.map((item, index) => (
                <StyledTimeline size={{ mobile: 1, desktop: 1 / 4 }}>
                  <StyledTimelineTitle mobile>{item.title}</StyledTimelineTitle>
                  <StyledTimelineBorder />
                  <StyledTimelinePoint />
                  <StyledTImelineResponsiveWrapper>
                    <StyledTimelineTitle laptop>{item.title}</StyledTimelineTitle>
                    <StyledTimelineDesciptionCard>
                      <StyledLogoWrapper>
                        <img
                          src={`../../../../static/images/about/${image[index]}.webp`}
                          alt="Logo"
                        />
                      </StyledLogoWrapper>
                      <StyledTimelineDesciption>{item.description}</StyledTimelineDesciption>
                    </StyledTimelineDesciptionCard>
                  </StyledTImelineResponsiveWrapper>
                </StyledTimeline>
              ))}
            </StyledTimelineWapper>
          </StyledAimMainWrapper>
        </StyledWidthWrapper>
      </StyledAimSection>
    </StyledCover>
  );
};

export default withTranslation('About')(Advantages);
